import FormattedDateTime from "../interfaces/format";

export const formatDuration = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (hours > 0) {
    return `${hours}h ${remainingMinutes} minutes`;
  } else {
    return `${minutes} minutes`;
  }
};


export const formatDateTime = (eventDate: string, timeZone: string): FormattedDateTime => {
  const dateObj = new Date(eventDate);

  const dateOptions: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const timeOptions: Intl.DateTimeFormatOptions = { hour: 'numeric', minute: 'numeric', hour12: true };

  const formattedDate: string = dateObj.toLocaleDateString('en-US', dateOptions);
  const formattedTime: string = dateObj.toLocaleTimeString('en-US', timeOptions);

  return { formattedDate, formattedTime, timeZone };
};